var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugustoPortfolioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.073 5.38645C22.8076 5.82684 23.3962 6.43198 23.8201 7.17283C24.2745 7.94159 24.4998 8.79068 24.4998 9.67875V24.5H16.6803V19.0976H11.7059V24.5H5.09498V22.4733H3.5V8.02441C3.5 7.21231 3.70585 6.44302 4.12825 5.7503C4.52573 5.08379 5.05888 4.53825 5.71932 4.13347L5.73612 4.12317C6.4367 3.7072 7.20901 3.5 8.02441 3.5H17.9265C18.7419 3.5 19.5141 3.70732 20.2147 4.12329C20.6256 4.36729 20.989 4.66448 21.3014 5.01147L22.073 5.38645Z",
    fill: "#1A1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90357 21.0696V8.02407C4.90357 7.45524 5.04578 6.93881 5.33019 6.47476C5.6146 5.99575 5.98883 5.61404 6.45287 5.32963C6.93188 5.04522 7.4558 4.90301 8.02463 4.90301H17.9267C18.4955 4.90301 19.0194 5.04522 19.4984 5.32963C19.9775 5.61404 20.3592 5.99575 20.6436 6.47476C20.928 6.93881 21.0702 7.45524 21.0702 8.02407V21.0696H18.0839V15.6359H7.86745V21.0696H4.90357ZM7.86745 12.672H18.0839V8.15879C18.0839 8.08394 18.0539 8.02407 17.994 7.97916C17.9342 7.91928 17.8668 7.88934 17.792 7.88934H8.1369C8.06205 7.88934 7.99469 7.91928 7.93481 7.97916C7.88991 8.02407 7.86745 8.08394 7.86745 8.15879V12.672Z",
    fill: "#5EC2EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugustoPortfolioLogo);
export default __webpack_public_path__ + "static/media/augusto-portfolio-logo.05d3d5f76e0301abf1e5822774481e21.svg";
export { ForwardRef as ReactComponent };